<template>
  <div class="allOrder" :style="listHeight">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      v-if="list.length != 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="lists" v-for="(item, index) in list" :key="index">
          <div>
            <van-row @click="orderDetail(item.ordersn)">
              <van-col span="24" class="title">
                <img src="@/assets/accountAgent/order/equipment_icon.png" />
                设备订单
                <span v-if="item.status == 10">待付款</span>
                <span v-if="item.status == 15 || item.status == 20"
                  >待发货</span
                >
                <span v-if="item.status == 30">待收货</span>
                <span v-if="item.status == 40 || item.status == 50"
                  >已完成</span
                >
                <span v-if="item.status == -10 || item.status == -20"
                  >已关闭</span
                >
              </van-col>
              <van-col
                span="24"
                class="content"
                v-show="item.order_goods.length > 0"
              >
                <img :src="item.order_goods[0].sku_image" />
                <p class="p_top">
                  <span class="name">{{ item.order_goods[0].goods_name }}</span>
                  <span class="price"
                    >￥{{ item.order_goods[0].sale_price }}</span
                  >
                </p>
                <p class="p_bottom">
                  x{{ item.order_goods[0].quantity }}
                  <span class="right"
                    >实付款<span
                      >￥<span>{{ item.amount.split(".")[0] }}</span
                      >.{{ item.amount.split(".")[1] }}</span
                    ></span
                  >
                </p>
              </van-col>
              <van-col span="24" class="line"></van-col>
              <van-col span="24" class="time">
                下单时间: <span>{{ item.created_at }}</span>
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-list>
    </van-pull-refresh>
    <van-row class="empty" v-if="list.length == 0 && !hasList">
      <van-col class="emptyMsg" span="24">
        <img src="@/assets/accountAgent/my/no_info.png" />
        <p class="tip">暂无订单</p>
      </van-col>
    </van-row>
    <div class="loading" v-if="list.length <= 0 && hasList">
      <img src="@/assets/accountAgent/common/loading.gif" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      allList: 11, //默认比第一页数据多1
      listHeight: {
        height: document.body.clientHeight - 88 + "px",
        padding: "0 1.2rem",
      },
      hasList: true,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      this.$api
        .post("/onorder/member/equipment/order/list", {
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;

          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    orderDetail(ordersn) {
      this.params(ordersn, ordersn, "orderDetail");
    },
  },
};
</script>
<style lang="less" scoped>
.allOrder {
  background-color: #f5f6f7;
  min-height: 100%;
  box-sizing: border-box;

  .empty {
    padding-top: 10rem;

    .emptyMsg {
      text-align: center;

      img {
        width: 22.1rem;
        display: inline-block;
      }

      .tip {
        color: #cccccc;
        font-size: 1.4rem;
        margin-top: 1.7rem;
        height: 2rem;
        line-height: 2rem;
      }
    }
  }

  .loading {
    width: 100%;
    /*padding-top: 100px;*/
    text-align: center;

    img {
      width: 35%;
      margin-top: 50%;
    }
  }

  .van-pull-refresh {
    height: 100%;
    box-sizing: border-box;
    padding-top: 0.9rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .lists {
      height: 18.1rem;
      border-radius: 0.8rem;
      background: #fff;
      padding: 1.5rem 1.2rem 0;
      margin-bottom: 0.9rem;

      .title {
        color: #333;
        font-size: 1.5rem;
        font-weight: 700;
        text-align: left;
        height: 2.4rem;
        line-height: 2.4rem;

        img {
          width: 2rem;
          margin-right: 0.6rem;
          float: left;
          margin-top: 0.2rem;
        }

        span {
          color: #f9591b;
          font-size: 1.4rem;
          float: right;
        }
      }

      .content {
        height: 10.3rem;
        padding: 0.9rem 0;
        padding-left: 9.6rem;
        position: relative;

        img {
          width: 8.4rem;
          height: 8.4rem;
          position: absolute;
          top: 0.9rem;
          left: 0;
          border-radius: 0.4rem;
        }

        .p_top {
          color: #333;
          font-size: 1.5rem;
          line-height: 2.1rem;
          margin-bottom: 2.1rem;
          position: relative;

          .name {
            height: 4.2rem;
            padding-right: 10rem;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
          }

          .price {
            position: absolute;
            right: 0;
            top: 0;
          }
        }

        .p_bottom {
          color: #999;
          font-size: 1.4rem;

          .right {
            float: right;
            height: 2.3rem;
            line-height: 2.3rem;
            color: #666;
            font-size: 1.3rem;

            span {
              color: #333;

              span {
                font-size: 1.7rem;
                font-weight: 700;
              }
            }
          }
        }
      }

      .line {
        height: 1px;
        background: -webkit-linear-gradient(
          to right,
          #ffffff,
          #f1f1f1
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          to right,
          #ffffff,
          #f1f1f1
        ); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          to right,
          #ffffff,
          #f1f1f1
        ); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right, #ffffff, #f1f1f1);
      }

      .time {
        height: 3.9rem;
        line-height: 3.9rem;
        font-size: 1.3rem;
        color: #666666;

        span {
          float: right;
        }
      }

      .money {
        height: 2.1rem;
        line-height: 2.1rem;
        font-size: 1.3rem;
        color: #666666;
        margin-top: 0.6rem;
        text-align: right;

        .num {
          color: #333;

          span {
            font-size: 1.7rem;
            font-weight: 700;
          }
        }
      }

      .tips {
        color: #333;
        font-size: 1.4rem;
        text-align: center;
        background: #f5f6f7;
        height: 2.9rem;
        line-height: 2.9rem;
        margin-top: 1.2rem;
      }
    }
  }
}
</style>